import anime from 'animejs';

const ANIM_EASING = 'easeInOutQuart';
const ANIM_DURATION = 800;
const ANIM_DELAY = 0;

class Popin {

  constructor(el) {
    this.el = el;
    this.inner = el.querySelector('.inner-popin-about');
  }

  show() {
    this.el.style.visibility = 'visible';
    this.el.style.pointerEvents = 'initial';
    this.inner.scrollTop = 0;

    anime({
      targets: this.el,
      translateY: ['-100%', '0%'],
      easing: ANIM_EASING,
      duration: ANIM_DURATION
    })

    anime({
      targets: this.inner,
      translateY: ['100%', '0%'],
      delay : ANIM_DELAY,
      easing: ANIM_EASING,
      duration: ANIM_DURATION
    })
  }

  hide() {
    anime({
      targets: this.el,
      translateY: '100%',
      easing: ANIM_EASING,
      duration: ANIM_DURATION,
      complete : ()=> {
        this.el.style.pointerEvents = 'none';
        this.el.style.visibility = 'visible';
      }
    })

    anime({
      targets: this.inner,
      translateY: '-100%',
      delay : ANIM_DELAY,
      easing: ANIM_EASING,
      duration: ANIM_DURATION
    })

  }

}

export default Popin;



// WEBPACK FOOTER //
// ./src/components/sections/Popin.js